import { sendPost } from '../http.js'
const api = {
	'tacode': '/user/talent/getcode ',
    'codeList':'user/talent/codelist',
    'videolist':'/user/talent/videolist',
    'addvideo':'/user/talent/addvideo',
    'deletevideo':'/user/talent/deletevideo'
}
export default {
	getTacode(params) {
	    return sendPost(api.tacode, params)
	},
    taCodeList(params) {
        return sendPost(api.codeList, params)
    },
    videolist(params) {
        return sendPost(api.videolist, params)
    },
    addvideo(params){
    	 return sendPost(api.addvideo, params)
    },
    deletevideo(params){
         return sendPost(api.deletevideo , params)
    },
}